import { eventBus } from '@/bus';
import { getController } from '@/controllers/request';
import router from '@/router/index';
import { EVENTBUS_EVENTS, MODULE } from '@/utils/constants';
import { errorMsg, mixin } from '@/utils/mixins';

export default {
  namespaced: true,
  state: {
    loading: false,
    currentUser: null,
    metadata: {},
    userMetadata: {},
    checkingForGoogleAuth: false,
    hasGoogleAuth: false,
    waitingForGoogleAuth: false,
    loadingCalendarList: false,
    disconnectingCalendar: false,
    connectedEmail: '',
    selectedCalendar: '',
    calendarList: []
  },
  mixins: [mixin],
  mutations: {
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setLoading(state, value) {
      state.loading = value;
    }
  },
  actions: {
    async loadUsers({ commit }) {
      commit('setParam', { name: 'loading', val: true });

      try {
        const intent = {
          module: 'Users',
          action: 'index',
          intentArea: 'DynamicPage',
          intentType: 'StaticPage',
          request: {
            url: '/index.php?module=Users&action=ListView',
            request_params: {
              displayMode: 'spa',
              Users2_USER_offset: 0
            }
          }
        };

        const request = await mixin.methods.sendFormRequestFromIntent(intent);
        const tableData = request.data?.data?.data?.data;
        const pageData = request.data?.data?.pageData;
        const sugarconfig = request.data?.sugarconfig;
        const customSearch = request.data?.custom_search;

        commit(
          'common/setTableData',
          {
            module: MODULE.USERS,
            columns: tableData?.title,
            rows: tableData?.rows
          },
          { root: true }
        );

        commit('selectionPopup/setMetadataFields', sugarconfig, {
          root: true
        });

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: sugarconfig
          },
          {
            root: true
          }
        );

        commit('selectionPopup/popupPageConfig', pageData, {
          root: true
        });

        commit('filters/setFiltersConfig', customSearch, {
          root: true
        });

        commit(
          'filters/setParam',
          {
            name: 'sortActive',
            val: !customSearch?.sortable?.default || false
          },
          { root: true }
        );

        commit('setParam', {
          name: 'metadata',
          val: request.data
        });

        if (tableData?.title_params) {
          commit('setParam', {
            name: 'tableTitleParams',
            val: tableData?.title_params
          });
        }
        commit('setParam', { name: 'loading', val: false });
        eventBus.$emit(EVENTBUS_EVENTS.UPDATE_TABLE);
      } catch (e) {
        console.error(e);
        commit('setParam', {
          name: 'metadata',
          val: { error: 'Доступ заблокирован' }
        });
      } finally {
        commit('setParam', { name: 'loading', val: false });
      }
    },
    async loadUser({ commit, state }, id) {
      if (!state.requestSent) {
        commit('setParam', {
          name: 'loading',
          val: true
        });
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setParam', {
                name: 'loading',
                val: true
              });
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setParam', {
                    name: 'loading',
                    val: false
                  });
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const response = await getController({
            params: {
              module: 'Users',
              action: 'getUserView',
              record: router?.history?.current?.fullPath?.includes('users')
                ? router?.history?.current?.params?.id || id
                : id
            }
          });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          commit('setParam', {
            name: 'userMetadata',
            val: response.data
          });

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            if (response.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async checkGoogleConnection({ commit, dispatch }) {
      commit('setParam', {
        name: 'checkingForGoogleAuth',
        val: true
      });
      const response = await getController({
        params: {
          module: 'Users',
          action: 'CheckGoogleConnection'
        }
      });
      if (response.data?.status === 'ok') {
        commit('setParam', {
          name: 'hasGoogleAuth',
          val: true
        });
        commit('setParam', {
          name: 'connectedEmail',
          val: response.data.data.email
        });
        dispatch('getCalendarsList');
      }
      // else if (response.data?.status === 'error') {
      //   errorMsg.methods.showNotification({
      //     offset: 100,
      //     showClose: true,
      //     message: response.data?.message || 'Ошибка',
      //     duration: 6500,
      //     type: 'error'
      //   });
      // }
      commit('setParam', {
        name: 'checkingForGoogleAuth',
        val: false
      });
    },
    async sendGoogleAuthRequest({ dispatch, commit, state }) {
      const response = await getController({
        params: {
          module: 'Users',
          action: 'SendAuthRequest'
        }
      });
      if (response.data?.status === 'ok') {
        window.open(response.data?.data?.redirect_uri, '_blank');

        if (!state.waitingForGoogleAuth) {
          commit('setParam', {
            name: 'waitingForGoogleAuth',
            val: true
          });
          dispatch('waitingForGoogleAuth');
        }
      } else if (response.data?.status === 'error') {
        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: response.data?.message || 'Ошибка',
          duration: 6500,
          type: 'error'
        });
      }
    },
    async waitingForGoogleAuth({ commit, dispatch }) {
      const timer = setInterval(async () => {
        const response = await getController({
          params: {
            module: 'Users',
            action: 'GetToken'
          }
        });
        if (response.data?.status === 'ok') {
          clearInterval(timer);
          commit('setParam', {
            name: 'hasGoogleAuth',
            val: true
          });
          commit('setParam', {
            name: 'connectedEmail',
            val: response.data.data.email
          });
          dispatch('getCalendarsList');
        }
      }, 2000);
    },
    async getCalendarsList({ commit, dispatch }) {
      commit('setParam', {
        name: 'loadingCalendarList',
        val: true
      });
      const response = await getController({
        params: {
          module: 'Users',
          action: 'GetCalendarsList'
        }
      });
      if (response.data?.status === 'ok') {
        const calendarsArray = [];
        Object.keys(response.data.data.calendars).forEach(calendarId => {
          calendarsArray.push({
            id: calendarId,
            name: response.data.data.calendars[calendarId]
          });
        });
        if (!response.data.data.selected) {
          dispatch(
            'saveSelectedCalendar',
            Object.keys(response.data.data.calendars)[0]
          );
        } else {
          commit('setParam', {
            name: 'selectedCalendar',
            val: response.data.data.selected
          });
        }
        commit('setParam', {
          name: 'calendarList',
          val: calendarsArray
        });
      } else if (response.data?.status === 'error') {
        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message:
            response.data?.message || 'Ошибка получения списка календаря',
          duration: 6500,
          type: 'error'
        });
      }
      commit('setParam', {
        name: 'loadingCalendarList',
        val: false
      });
    },
    async saveSelectedCalendar({ commit }, calendarId) {
      const response = await getController({
        params: {
          module: 'Users',
          action: 'saveCalendars',
          calendar_folder_id: calendarId || ''
        }
      });
      if (response.data?.status === 'ok') {
        commit('setParam', {
          name: 'selectedCalendar',
          val: calendarId
        });
      } else if (response.data?.status === 'error') {
        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: response.data?.message || 'Ошибка сохранения календаря',
          duration: 6500,
          type: 'error'
        });
      }
    },
    async googleCalendarDisconnect({ commit }) {
      commit('setParam', {
        name: 'disconnectingCalendar',
        val: true
      });
      const response = await getController({
        params: {
          module: 'Users',
          action: 'googleCalendarDisconnect'
        }
      });
      if (response.data?.status === 'ok') {
        commit('setParam', {
          name: 'hasGoogleAuth',
          val: false
        });
      } else if (response.data?.status === 'error') {
        errorMsg.methods.showNotification({
          offset: 100,
          showClose: true,
          message: response.data?.message || 'Ошибка отключения календаря',
          duration: 6500,
          type: 'error'
        });
      }
      commit('setParam', {
        name: 'disconnectingCalendar',
        val: false
      });
    }
  }
};
